import { render } from "./SListItem.vue?vue&type=template&id=536165bc&scoped=true&ts=true"
import script from "./SListItem.ts?vue&type=script&lang=ts"
export * from "./SListItem.ts?vue&type=script&lang=ts"

import "./SListItem.scss?vue&type=style&index=0&id=536165bc&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536165bc"]])

export default __exports__